import type { EntityMovedPayload } from '@trames/shared/schemas';

/**
 * Interpolación lineal entre dos snapshots por entidad (TKT-015).
 * Si una entidad aparece en `to` pero no en `from`, se usa la posición de `to`
 * tal cual (entrada nueva → sin tramo previo). Inverso simétrico para salidas.
 */

export interface EntitySample {
  entityId: string;
  position: { x: number; y: number };
  velocity: { x: number; y: number };
}

export function interpolateEntities(
  from: EntityMovedPayload[],
  to: EntityMovedPayload[],
  t: number,
): EntitySample[] {
  const fromById = new Map(from.map((e) => [e.entityId, e]));
  const out: EntitySample[] = [];
  for (const target of to) {
    const prev = fromById.get(target.entityId);
    if (!prev) {
      out.push({
        entityId: target.entityId,
        position: target.position,
        velocity: target.velocity,
      });
      continue;
    }
    out.push({
      entityId: target.entityId,
      position: {
        x: prev.position.x + (target.position.x - prev.position.x) * t,
        y: prev.position.y + (target.position.y - prev.position.y) * t,
      },
      velocity: target.velocity,
    });
  }
  return out;
}
